import React from 'react';
import { TrendingUp, TrendingDown, RefreshCw } from 'lucide-react';
import { Button } from '../ui/button';

export function MarketWatchWidget({ marketData, marketSource, marketLoading, onRefresh }) {
  return (
    <div className="bg-[#141417] border border-[#27272A] rounded-md p-6 mb-8">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-[#007AFF]/10 rounded-md flex items-center justify-center">
            <TrendingUp className="w-5 h-5 text-[#007AFF]" />
          </div>
          <div>
            <h2 className="text-xl font-bold text-white" style={{ fontFamily: 'Chivo, sans-serif' }}>
              Market Watch
            </h2>
            <p className="text-[#71717A] text-sm">
              Real-time prices &bull; Source: {marketSource === 'alpha_vantage' ? 'Alpha Vantage' : 'Demo Data'}
            </p>
          </div>
        </div>
        <Button 
          variant="outline" 
          className="border-[#27272A] text-[#A1A1AA]"
          onClick={onRefresh}
          disabled={marketLoading}
          data-testid="refresh-market-btn"
        >
          <RefreshCw className={`w-4 h-4 mr-2 ${marketLoading ? 'animate-spin' : ''}`} />
          Refresh
        </Button>
      </div>
      
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {marketData.map(item => (
          <div 
            key={item.symbol}
            className="bg-[#09090B] border border-[#27272A] rounded-md p-4"
            data-testid={`market-${item.symbol}`}
          >
            <div className="flex items-center justify-between mb-2">
              <span className="font-mono text-white font-bold">{item.symbol}</span>
              {item.change >= 0 ? (
                <TrendingUp className="w-4 h-4 text-[#00FF66]" />
              ) : (
                <TrendingDown className="w-4 h-4 text-[#FF3333]" />
              )}
            </div>
            <p className="text-[#71717A] text-xs mb-1">{item.name}</p>
            <p className="text-xl font-bold text-white font-mono">${item.price.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
            <p className={`text-sm font-mono ${item.change >= 0 ? 'ticker-up' : 'ticker-down'}`}>
              {item.change >= 0 ? '+' : ''}{item.change.toFixed(2)} ({item.change_percent.toFixed(2)}%)
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
